export default "__VITE_ASSET__DNpNGk3s__"